import React, { useState, useEffect } from 'react';

import { Container, Filler } from './styles';

export interface Props {
  steps: number;
  actualStep: number;
}

const ProgressBar = ({ steps, actualStep }: Props) => {
  const calculateWidth = (step: number) => (100 / steps) * step;
  const [width, setWidth] = useState(calculateWidth(actualStep - 1));

  useEffect(() => {
    requestAnimationFrame(() => {
      setWidth(calculateWidth(actualStep));
    });
  });

  return (
    <Container>
      <Filler percentage={width} />
    </Container>
  );
};

export default ProgressBar;
